module.exports = __webpack_public_path__ + "static/media/ekkelt.46630707.mp3";